// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum ClientEndpointCadenceUnit {
	Seconds = 0,
	Minutes = 1,
	Hours = 2,
	Daily = 3,
}

export const ClientEndpointCadenceUnitDisplayNames: { [key in keyof typeof ClientEndpointCadenceUnit]?: string} = {
	"Seconds": "Seconds",
	0 : "Seconds",
	"Minutes": "Minutes",
	1 : "Minutes",
	"Hours": "Hours",
	2 : "Hours",
	"Daily": "Daily at a time (UTC)",
	3 : "Daily at a time (UTC)",
}

export const getClientEndpointCadenceUnitDisplayName = (key: ClientEndpointCadenceUnit | (keyof typeof ClientEndpointCadenceUnit & string)) => {
	return ClientEndpointCadenceUnitDisplayNames[key];
}

